export default __webpack_public_path__ + "static/media/pricing-mrp-gray-icon.b81288d9.webp";